import { TvCashItemManager } from '../Managers/TvCashItemManager';
export class TvHistorySubscriptionsContainer {
    constructor() {
        this.waitingSubscriptionsMap = new Map();
        this.subscriptionsMap = new Map();
    }
    insertCashItem(interiorId, resolution, cashItem, timeOffset, timeZone) {
        const tvCashItem = new TvCashItemManager(cashItem, timeOffset, timeZone);
        const key = this.createKey(interiorId, resolution);
        this.waitingSubscriptionsMap.set(key, tvCashItem);
    }
    subscribeBars(interiorId, resolution, subscriberUID, onRealtimeCallback, onResetCacheNeededCallback) {
        const key = this.createKey(interiorId, resolution);
        const tvCashItem = this.waitingSubscriptionsMap.get(key);
        if (!tvCashItem) {
            console.log(`[TvSubscriptionsContainer::subscribeBars]: CashItem not found for ${key}`);
            return;
        }
        this.waitingSubscriptionsMap.delete(key);
        tvCashItem.setCallBacks(onRealtimeCallback, onResetCacheNeededCallback);
        this.subscriptionsMap.set(subscriberUID, tvCashItem);
    }
    unsubscribeBars(subscriberUID) {
        const tvCashItem = this.subscriptionsMap.get(subscriberUID);
        if (!tvCashItem) {
            console.log(`[TvSubscriptionsContainer::unsubscribeBars]: CashItem not found for ${subscriberUID}`);
            return;
        }
        this.subscriptionsMap.delete(subscriberUID);
        tvCashItem.dispose();
    }
    resetCacheByNewAccount() {
        this.subscriptionsMap.forEach((tvCashItem) => {
            tvCashItem.callOnResetCacheNeededCallback();
        });
    }
    createKey(interiorId, resolution) {
        return `${interiorId}_${resolution}`;
    }
    dispose() {
        this.waitingSubscriptionsMap.forEach((tvCashItem) => {
            tvCashItem.dispose();
        });
        this.waitingSubscriptionsMap.clear();
        this.subscriptionsMap.forEach((tvCashItem) => {
            tvCashItem.dispose();
        });
        this.subscriptionsMap.clear();
    }
}
